<template>
  <!-- 结算页面 -->
  <div class="page" style="background: #F1F1F1;">
    <div class="header">
      <van-nav-bar
              title="确认订单"
              left-text="返回"
              left-arrow
              @click-left="()=>{this.$router.go(-1)}"
      />
    </div>
    <div class="main" style="background: #F1F1F1;padding-bottom:100px">
      <van-notice-bar mode="link" v-if="carList.length == 0" @click="()=>{this.$router.push('/create/car')}">
        还未添加车辆，点击前往添加
      </van-notice-bar>
      <van-cell-group v-if="carList.length > 0">
        <van-cell title="年检车辆" center :value="chooseCarResult === '' ? '请选择年检车辆' : chooseCarResult" is-link
                  @click="()=>{this.chooseCarShow=true}"/>
      </van-cell-group>
      <div class="service" v-if="order.orderType==18">
        <div class="service__title">代驾车检服务</div>
        <div class="service__content">
          <van-steps :active="active" active-icon="arrow" inactive-icon="arrow" active-color="#969799">
            <van-step>提交订单</van-step>
            <van-step>司机接车</van-step>
            <van-step>站点年检</van-step>
            <van-step>司机还车</van-step>
          </van-steps>
        </div>
      </div>
      <div class="service" v-if="order.orderType==17">
        <div class="service__title">预约车检服务</div>
        <div class="service__content">
          <van-steps :active="active" active-icon="arrow" inactive-icon="arrow" active-color="#969799">
            <van-step>提交订单</van-step>
            <van-step>客服沟通确认时间</van-step>
            <van-step>自行开车到站点</van-step>
            <van-step>站点年检</van-step>
          </van-steps>
        </div>
      </div>
      <div class="planTime">
        <van-cell title="预约日期" center :value="order.planDate"/>
        <van-cell title="预约时间" center :value="order.planTime"/>
        <van-cell title="接车地址" center :value="`${order.location}${order.address}`" v-if="order.orderType == 18"/>
        <van-cell title="预约站点" center :value="storeName" v-if="order.orderType == 17"/>
        <van-field label="车主姓名" v-model="customerName" placeholder="请输入车主姓名"/>
        <van-field label="联系方式" max-length="11" v-model="customerMobile" placeholder="请输入车主手机号" type="tel"/>
      </div>


      <div class="price-item-list">

        <van-cell-group v-if="order.orderType == 18">
          <van-cell title="总计">
            <div class="price" style="color:#222222">
              <span class="unit">￥</span>{{sumPrice.toFixed(2)}}
            </div>
          </van-cell>
          <van-cell title="接车费" v-if="pickCarPrice != null">
            <div class="price">
              <span class="unit">￥</span>{{pickCarPrice}}
            </div>
          </van-cell>
        </van-cell-group>

        <van-cell-group v-if="order.orderType == 17">
          <van-cell title="总计">
            <div class="price" style="color:#222222">
              <span class="unit">￥</span>{{sumPrice.toFixed(2)}}
            </div>
          </van-cell>
          <van-cell title="网约代办年检服务费" >
            <div class="price">
              +<span class="unit">￥</span>20
            </div>
          </van-cell>
          <van-cell title="活动减免" >
            <div class="price">
              -<span class="unit">￥</span>20
            </div>
          </van-cell>
          <van-cell title="网约代办年检服务费" v-if="agentPrice != null && agentPrice > 0">
            <div class="price">
              +<span class="unit">￥</span>{{agentPrice.toFixed(2)}}
            </div>
          </van-cell>
        </van-cell-group>

      </div>
    </div>


    <van-submit-bar :price="sumPrice * 100" button-text="提交订单" @submit="onSubmit">
      <template #tip v-if="order.orderType == 17 && serviceConfig.length == 0">
        本次支付的价格不包含检测站检测费用
      </template>
    </van-submit-bar>

    <van-popup v-model="chooseCarShow" position="bottom">
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="()=>{this.chooseCarShow=false}">取消</button>
        <div class="van-ellipsis van-picker__title">选择车辆</div>
        <button type="button" class="van-picker__confirm" @click="()=>{this.chooseCarShow=false}">确认</button>
      </div>
      <div class="car-list">
        <van-radio-group v-model="chooseCarResult">
          <van-cell-group>
            <van-cell
                    v-for="item in carList"
                    :label="item.remark"
                    clickable
                    :key="item.plateNum"
                    :title="`${item.plateNum}`"
                    @click="chooseCarResult = item.plateNum"
            >
              <template #right-icon>
                <van-radio :name="item.plateNum" checked-color="#549B41"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>

      <div class="add-car">
        <van-button block round style="background: #62A348;color:#FFF;width: 80%;margin:20px auto;" to="/create/car">
          添加车辆
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {
    CellGroup,
    Button,
    Cell,
    NoticeBar,
    RadioGroup,
    Radio,
    NavBar,
    Step,
    Steps,
    SubmitBar,
    Field,
    Popup,
    Toast, Notify
  } from 'vant';
  import {mapState} from "vuex";
  import {checkMobile} from '../utils/validateUtils'
  import {getDictItemByCode} from "../services/system/dictService";

  export default {
    name: "settlement",
    components: {
      vanCell: Cell,
      vanCellGroup: CellGroup,
      vanNavBar: NavBar,
      vanStep: Step,
      vanSteps: Steps,
      vanSubmitBar: SubmitBar,
      vanField: Field,
      vanPopup: Popup,
      vanRadio: Radio,
      vanRadioGroup: RadioGroup,
      vanButton: Button,
      vanNoticeBar: NoticeBar
    },
    data() {
      return {
        plateNum: '',
        storeName: '',
        active: 0,
        chooseCarShow: false,
        chooseCarResult: '',
        carList: [],
        pickCarPrice: null,
        inspectPrice: null,
        customerName: '',
        customerMobile: '',
        sumPrice: 0,
        serviceConfig: [],
        agentPrice:0,
      }
    },
    computed: {
      ...mapState({
        order: state => {
          console.log(state.order.order,'settlement-order');
          return state.order.order;
        }
      }),
    },
    methods: {
      onSubmit() {

        if (this.chooseCarResult == '') {
          Notify("请选择要年检的车辆");
          return;
        }
        if (this.customerName == '') {
          Notify("请填写车主姓名");
          return;
        }
        if (!checkMobile(this.customerMobile)) {
          Notify("请填写正确的手机号");
          return;
        }

        this.$http.post("/wechat/order/submit", {
          customerName: this.customerName,
          customerMobile: this.customerMobile,
          customerPlateNum: this.chooseCarResult,
          planTime: `${this.order.planDate} ${this.order.planTime}:00`,
          houseAddress: this.order.orderType == 18 ? `${this.order.location}${this.order.address}` : null,
          sourceType: 1,
          serviceStoreId: this.order.storeId,
          orderType: this.order.orderType,
          pickCarServiceConfigId: this.order.configId
        })
          .then(resp => {
            if (resp.success) {
              const _this = this;
              if (resp.data.noPay && resp.data.noPay == "true") {
                _this.$router.replace({path: '/order/list'});
                return;
              }
              const data = resp.data;
              this.$wechat.chooseWXPay({
                timestamp: data.timeStamp,
                nonceStr: data.nonceStr,
                package: data.package,
                signType: data.signType,
                paySign: data.paySign,
                success: function () {
                  Toast.loading({
                    mask: true,
                    message: '处理订单中...',
                    onClose: () => {
                      _this.$router.replace({path: '/order/list'});
                    }
                  });
                },
                cancel: function () {
                  Toast.fail('支付取消');
                  _this.$router.replace({path: '/order/list'});
                }
              })
            } else {
              Notify(resp.message);
            }
          })
          .catch(error => {
            console.log(error);
          })
      },
      loadOutletDetail() {
        const id = this.order.storeId;
        this.$http.get(`/store/${id}`)
          .then(resp => {
            if (resp.success) {
              this.storeName = resp.data.storeName;
            }
          })
          .catch(error => {
            console.log(error);
          })
      },
      getCarList() {
        this.$http.get("/my/car")
          .then(resp => {
            if (resp.success) {
              this.carList = resp.data;
            }
          })
      },
      getPickCarConfig() {
        const configId = this.order.configId;
        this.$http.get(`/pickcar/config/${configId}`).then(resp => {
          if (resp.success) {
            this.sumPrice = resp.data.inspectPrice + resp.data.pickCarPrice;
          } else {
            Notify("该城市尚未开通接车服务");
          }
        })
      },
      getCymPrice() {
        getDictItemByCode('CYM_PRICE_DBNJ').then(resp => {
          if(resp.success){
            this.agentPrice = Number(resp.data.val);
            //this.getStoreServiceConfig();
            this.sumPrice +=  this.agentPrice;
          }
        })
      },
      getStoreServiceConfig() {
        const id = this.order.storeId;
        this.$http.get(`/store/${id}/service/config`)
          .then(resp => {
            if (resp.success) {
              this.serviceConfig = resp.data;
              if (this.serviceConfig.length > 0) {
                const {price, servicePrice} = this.serviceConfig[0];
                this.sumPrice += (price + servicePrice);

              }
            }
          })
          .catch(error => {
            console.log(error);
          })
      }
    },
    created() {

      if (this.order.orderType == 18) {
        this.getPickCarConfig();
      } else {
        this.loadOutletDetail();

        this.getCymPrice();
      }
      this.getCarList();

    }
  }
</script>

<style lang="less" scoped>
  .service {
    padding: 16px;
    background: #FFF;
    margin-top: 10px;

    &__title {
      font-size: 18px;
    }

    &__content {
      margin-top: 16px;
      background: #F1F1F1;
    }
  }

  .planTime {
    margin-top: 10px;
  }

  .price-item-list {
    margin-top: 10px;
  }

  .price {
    color: #E54A4A;

    .unit {
      font-size: 10px;
    }
  }

  .choose-car__top {
    display: flex;
    justify-content: space-between;

    .cancel, .confirm {
      background: transparent;
    }
  }

  .car-list {
    display: flex;
    flex-direction: column;
    margin-top: 50px;
  }
</style>
